import Breadcrumb, { IBreadcrumb } from './Breadcrumb';

export type { IBreadcrumb };
export default Breadcrumb;
